// @flow

import * as React from 'react';
import t from 'app/utils/translate';
import LightTab from 'app/components/commons/LightTab';
import LightTabSet from 'app/components/commons/LightTabSet';
import MenuWrapper from 'app/components/commons/MenuWrapper';

type Props = {
  active: 'completed' | 'live' | 'upcoming',
  rest?: string
};

const defaultProps = {
  rest: undefined
};

function MyChallengesMenu({ active, rest }: Props) {
  const restStr = rest ? `/${rest}` : '';

  return (
    <MenuWrapper component={LightTabSet} value={active}>
      <LightTab id="live" to={`/my-challenges/live${restStr}`}>
        {t('Live')}
      </LightTab>
      <LightTab id="upcoming" to={`/my-challenges/upcoming${restStr}`}>
        {t('Upcoming')}
      </LightTab>
      <LightTab id="completed" to={`/my-challenges/completed${restStr}`}>
        {t('Completed')}
      </LightTab>
    </MenuWrapper>
  );
}

MyChallengesMenu.defaultProps = defaultProps;

export default MyChallengesMenu;
